import React from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Shown when a deep link points at something that doesn't exist for this user
 * (e.g. a session that was deleted or belongs to another account). We render a
 * 404 in place rather than redirecting so the bad URL stays visible and the
 * user understands what happened.
 */
const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { orgSlug } = useParams<{ orgSlug: string }>();

  return (
    <div className="flex flex-col flex-1 h-full min-w-0 items-center justify-center gap-4 text-center px-6">
      <span className="material-symbols-outlined text-6xl text-slate-600">
        error
      </span>
      <div className="text-2xl font-bold font-headline text-on-surface">
        404 — Not Found
      </div>
      <p className="text-slate-400 font-body max-w-md">
        We couldn&apos;t find that session. It may have been deleted, or it
        belongs to a different account.
      </p>
      <button
        onClick={() => navigate(`/${orgSlug}/library`)}
        className="px-4 py-2 bg-surface-container hover:bg-surface-container-high rounded text-on-surface transition-colors font-label text-sm uppercase tracking-wider"
      >
        Back to Library
      </button>
    </div>
  );
};

export default NotFoundPage;
